


























import { Component, Mixins, Prop } from "vue-property-decorator";
import RequestedDocumentProcessor from "./helpers/RequestedDocumentProcessor.vue";
import { FixedLoading } from "../system";
import { ExistingDocumentEditor } from "./editors";
import {
  EmbeddedDocumentEditViewMixin,
} from "./mixins";

@Component({
  components: {
    FixedLoading,
    ExistingDocumentEditor,
    RequestedDocumentProcessor,
  },
})
export default class EmbeddedNewCopiedDocumentEditView extends Mixins(EmbeddedDocumentEditViewMixin) {
  @Prop()
  copiedDocumentId: number;

  @Prop()
  chainedFormatIds: number[];

  $refs!: {
    processor: RequestedDocumentProcessor;
    copiedEditor: ExistingDocumentEditor;
  };

  mounted() {
    this.embeddedComponent = this.$refs.copiedEditor;
  }
}
